import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type DeletePushTokenOptions<
  TDocRef = unknown,
  TDb = FirestoreInstance,
> = {
  token: string;
  db: TDb;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  deleteDoc: (ref: NoInfer<TDocRef>) => Promise<void> | void;
};

export const deletePushToken = async <TDocRef, TDb = FirestoreInstance>({
  token,
  db,
  doc,
  deleteDoc,
}: DeletePushTokenOptions<TDocRef, TDb>): Promise<void> => {
  if (!token) {
    return;
  }
  await deleteDoc(doc(db, FirestoreCollections.FcmTokens, token));
};
